import { WHATSAPP_LINK, DEFAULT_WA_MESSAGE } from "@/lib/site";

// Floating WhatsApp button — fixed bottom-right on every page.
export default function WhatsAppButton() {
  return (
    <a
      href={WHATSAPP_LINK(DEFAULT_WA_MESSAGE)}
      target="_blank"
      rel="noreferrer"
      data-testid="floating-whatsapp"
      aria-label="Chat with Fly Gowell on WhatsApp"
      className="fixed bottom-6 right-6 z-50 group"
    >
      <span className="absolute inset-0 rounded-full bg-brand-green/40 animate-ping" />
      <span className="relative flex h-14 w-14 items-center justify-center rounded-full bg-brand-green text-white shadow-xl transition-transform group-hover:scale-110">
        <svg viewBox="0 0 32 32" className="h-7 w-7 fill-current" aria-hidden="true">
          <path d="M16.003 3C9.383 3 4 8.383 4 15.003c0 2.117.553 4.184 1.605 6.008L4 29l8.184-1.57a11.94 11.94 0 0 0 3.819.626h.003C22.626 28.056 28 22.673 28 16.053 28 12.84 26.75 9.82 24.48 7.55 22.21 5.28 19.216 3 16.003 3Zm0 21.85h-.003a9.87 9.87 0 0 1-3.026-.478l-.217-.07-4.856.932.99-4.73-.14-.242a9.83 9.83 0 0 1-1.51-5.16c0-5.44 4.43-9.87 9.87-9.87 2.637 0 5.115 1.028 6.98 2.893a9.79 9.79 0 0 1 2.888 6.977c0 5.44-4.43 9.87-9.86 9.87Zm5.412-7.39c-.297-.149-1.758-.868-2.03-.967-.272-.099-.47-.148-.668.15-.198.297-.767.966-.94 1.164-.173.198-.347.223-.644.075-.297-.149-1.255-.463-2.39-1.475-.883-.788-1.48-1.76-1.653-2.057-.173-.297-.019-.458.13-.606.134-.133.297-.347.446-.52.15-.174.198-.298.298-.496.099-.198.05-.372-.025-.52-.074-.15-.668-1.611-.916-2.206-.24-.579-.485-.5-.668-.51l-.57-.01a1.1 1.1 0 0 0-.792.372c-.272.297-1.04 1.016-1.04 2.478 0 1.462 1.065 2.874 1.214 3.072.148.198 2.095 3.2 5.076 4.487.71.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.247-.694.247-1.29.173-1.414-.074-.124-.272-.198-.57-.347Z" />
        </svg>
      </span>
    </a>
  );
}
